import React from 'react'

const BulkDownloadErrorIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <circle cx="8" cy="8" r="8" fill="#C00B00" />
            <path d="M7.55566 4.44402H8.44455V9.3329H7.55566V4.44402ZM8.44455 10.6662V11.5551H7.55566V10.6662H8.44455Z" fill="white" />
        </svg>
    )
}

export default BulkDownloadErrorIcon